// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Wrench = function Wrench(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14.417 3.979l-3.332 3.333L8.677 4.9l3.328-3.328a4.791 4.791 0 00-6.661 5.273 2.39 2.39 0 01-.665 2.069l-3.52 3.52 2.406 2.406 3.521-3.518a2.391 2.391 0 012.1-.661 4.79 4.79 0 005.234-6.682z"
    }))
  );
};

export default Wrench;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Wrench.js
// module id = 1064
// module chunks = 0